import { render, staticRenderFns } from "./BasicExamFindingRecord.vue?vue&type=template&id=3c6a7d04&"
import script from "./BasicExamFindingRecord.vue?vue&type=script&lang=js&"
export * from "./BasicExamFindingRecord.vue?vue&type=script&lang=js&"
import style0 from "./BasicExamFindingRecord.vue?vue&type=style&index=0&id=3c6a7d04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports